import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Copy, Check } from 'lucide-react';
import { Button } from '../../../shared/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '../../../shared/components/ui/tooltip';
import { toast } from 'sonner';

export const HeadlineCard = ({ headline, index }) => {
  const [copied, setCopied] = useState(false);
  const charCount = headline.length;
  
  const getCharCountColor = () => {
    if (charCount <= 120) return 'text-success';
    if (charCount <= 180) return 'text-primary';
    return 'text-accent';
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(headline);
      setCopied(true);
      toast.success('Headline copied to clipboard!');
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error('Failed to copy headline');
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      className="headline-card rounded-xl p-5 group"
    >
      <div className="flex items-start gap-4">
        <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
          <span className="text-sm font-bold text-primary">{index + 1}</span>
        </div>
        <div className="flex-1">
          <p className="text-foreground text-base leading-relaxed font-medium mb-3">
            {headline}
          </p>
          <div className="flex items-center justify-between">
            <span className={`text-xs font-medium ${getCharCountColor()}`}>
              {charCount}/220 characters
            </span>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={handleCopy}
                    className="gap-2"
                  >
                    {copied ? (
                      <>
                        <Check className="w-4 h-4 text-success" />
                        Copied
                      </>
                    ) : (
                      <>
                        <Copy className="w-4 h-4" />
                        Copy
                      </>
                    )}
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  <p>Copy headline to clipboard</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
